import { sendRequest } from '@/Configs';
import { API } from '@constants';
import { LoginStructure } from '@/Interfaces/Auth.interface';

const { AUTH } = API;

export const login = async (payload: LoginStructure) => {
  return await sendRequest(AUTH.LOGIN, 'POST', payload);
};
